module.exports = __webpack_public_path__ + "img/promotion-basic.8ec37552.svg";